import { State } from 'store/types';
import { useStoreon } from 'storeon/react';

export const isBasket = (path: string): boolean => path.replace(/\//g, '') === 'basket';

export const useIsBasket = (): boolean => {
  const { path } = useStoreon<State>('path');
  return isBasket(path);
};
